<template>
  <div class="countryContainer">
    <div :class="country.is_chapter ? 'countryName clickable': 'countryName'">
      <span v-if="country.is_chapter" class="facebookIcon">
        <!-- <FontAwesomeIcon :icon="['fab', 'facebook']" /> -->
        <chapter-detail :chapter="country" country="true" class='countryChapter'/>
      </span>
      <span v-if="!country.is_chapter">
        {{country.name}}
      </span>
    </div>

    <div v-if="!country.is_chapter">
      <div v-for="chapter of sortedChaptersForCountry" :key="chapter.name">
        <chapter-detail :chapter="chapter"/>
      </div>
    </div>
  </div>
</template>
<script>

// import { Country } from '../store/regions/types'
import ChapterDetail from './ChapterDetail.vue'

// import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

export default {
  name: 'CountryDetail',
  props: ['country'],
  components: { ChapterDetail }, //, FontAwesomeIcon }
  data() {
    return {
      sortedChaptersForCountry: []
    }
  },
  mounted() {
    if (this.country && this.country.chapters) {
      this.sortedChaptersForCountry = this.country.chapters.sort((a, b) => (a.name > b.name) ? 1 : -1)
    }
  }
}

</script>

<style lang="scss" scoped>
.countryContainer {
  margin-bottom: 10px;
  .countryName {
    font-weight:bold;
    text-decoration:underline;
  }

  .clickable {
    cursor: pointer;
    text-decoration:none;
    &:hover {
      text-decoration: underline;
    }
  }

  .facebookIcon {
    font-size:0.8em;
    color: #294875;
  }

  .countryChapter{
    font-size: 1.1em;
    text-decoration: underline;
  }
}
</style>
